import {Fragment, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {FormatDisplay} from '../../../shared/format';

import {MGateWayService} from '../../lich-su-truyen-nhan/MGateWayService';
import {ToastService} from '../../../AppToast';
import {ConfirmDialogService} from '../../../AppConfirmDialog';

import {TransferLogs} from '../../lich-su-truyen-nhan/component/TransferLogs';
import  EventEmitter  from '../../../utils/EventEmitter';
import {localized, useTranslation} from '../../../shared/language';

export const DialogViewTransferLog = (props) => {
  const {t} = useTranslation();

  const type = 'Invoice,InvoiceCode,InvoiceCash';
  const sendTaxStatusError = 5;
  
  const {display, setDisplay, selectedItem} = props;
  const [version, setVersion] = useState(null);
  const [canRollback, setCanRollback] = useState(false);
  const [canRevert, setCanRevert] = useState(false);

  const rollbackStatus = () => {
    ConfirmDialogService.confirm(localized('common.confirm'), localized('common.restoreInvoiceStatusQuestion'), () => {
      MGateWayService.rollbackStatus(type, [selectedItem.id]).then(() => {
        setVersion(Date.now());
        ToastService.success(localized('common.restoreSuccess'));
      });
    });
  }

  const revertStatus = () => {
    const searchInvoice =  {
      invoiceId: selectedItem.id,
      taxCode: selectedItem.sellerTaxCode,
      invoiceDate:selectedItem.invoiceDate,
      invoiceNo: selectedItem.invoiceNumber,
      invoiceSerial: selectedItem.invoiceSerial,
      sendTaxStatus: selectedItem.invoiceSerial
    };

    ConfirmDialogService.confirm(localized('common.confirm'), localized('common.retrieveSuccessMessageQuestion'), () => {
      MGateWayService.revertStatus(searchInvoice).then(() => {
        setVersion(Date.now());
        ToastService.success(localized('common.retrieveSuccess'));
        EventEmitter.emit("reloadInvoiceData");
      });
    });
  }

  const getResult = () => {
    if((selectedItem.sendTaxStatus === sendTaxStatusError)) {
      revertStatus();
    } else {
      reloadResult();
    }
  }

  const reloadResult = () => {
      MGateWayService.getResult(selectedItem.id, type).then(() => {
      setVersion(Date.now());
      ToastService.success(localized('common.reloadSuccess'));
      EventEmitter.emit("reloadInvoiceData");
    });
  }   

  return (
    <Dialog header={t('common.invoiceTransferHistory')} visible={display} style={{width: '80vw'}} position="top" onHide={() => setDisplay(false)}>
      {selectedItem &&
				<Fragment>
					<p className="text-center"><b style={{fontSize: '1.25rem', fontWeight: 700}}>{t('common.symbol')} {selectedItem.invoiceSerial}, {t('common.invoiceNo').toLowerCase()} {selectedItem.invoiceNumber}, {t('common.invoiceDate').toLowerCase()} {FormatDisplay.date(selectedItem.invoiceDate)}</b></p>
					<TransferLogs type={type} invoice={selectedItem} rows={20} heightCalc={200} idAction={selectedItem.id} version={version} sendTaxStatus = {selectedItem.sendTaxStatus}
												setCanRollback={setCanRollback}/>
				</Fragment>
      }

      <div className="flex justify-content-end mt-2">
        {/* {canRollback &&
					<Button label={t('common.restoreStatus')} className="p-button-outlined p-button-sm mr-2" onClick={rollbackStatus}/>
        } */}
        <Button label={t('common.check')} className="p-button-outlined p-button-sm mr-2" onClick={getResult}/>
        <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-outlined p-button-secondary p-button-sm"/>
      </div>
    </Dialog>
  );
}
